export default "dist/images/components-columns-width-control-2-1.00780d9.png";